// Exports
export default {
	"overlayChangeAccountContainer": "overlayChangeAccountContainer_Spw0i",
	"icon": "icon_wyQph",
	"message": "message_lVnQ-",
	"input": "input_p-MOA"
};
